<template>
  <p :class="classNames" :style="textStyle">{{ this.resultText }}</p>
</template>

<script>
import { numberWithComma } from '@/utils/common.js'

export const TextType = Object.freeze({
  String: false,
  Number: true
})

export const TextColor = Object.freeze({
  brand: 'brand',
  brand2: 'brand-2',
  gray: 'gray',
  gray2: 'gray-2',
  gray3: 'gray-3',
  gray4: 'gray-4',
  gray5: 'gray-5',
  darkGray: 'dark-gray',
  black: 'black',
  white: 'white',
  disable: 'disable',
  inactive: 'inactive',
  warning: 'warning',
  emergency: 'emergency'
})

export const TextWeight = Object.freeze({
  extraThin: 'extra-thin',
  thin: 'thin',
  regular: 'regular',
  bold: 'bold',
  extraBold: 'extra-bold'
})

export default {
  name: 'VP',
  props: {
    text: {
      type: [String, Number],
      required: true
    },
    type: {
      type: Boolean,
      default: TextType.String
    },
    color: {
      type: String,
      default: TextColor.black
    },
    size: {
      type: Number,
      default: 12
    },
    weight: {
      type: String,
      default: TextWeight.regular
    }
  },
  computed: {
    textStyle() {
      return { fontSize: `${this.size}px` }
    },
    classNames() {
      return ['default', this.color, this.weight]
    },
    resultText() {
      return this.type === TextType.Number ? numberWithComma(this.text) : this.text
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';
@import '~@/assets/scss/modules/text';

.default {
  text-align: center;
}

.brand {
  color: $brand;
}

.gray {
  color: $light-gray-3;
}

.gray-2 {
  color: $gray-3;
}

.gray-3 {
  color: $gray-4;
}

.gray-4 {
  color: $light-gray-5;
}

.gray-5 {
  color: $light-gray-10;
}

.dark-gray {
  color: $dark-gray;
}

.black {
  color: $black;
}

.white {
  color: $white;
}

.disable {
  color: $gray-3;
}

.inactive {
  color: $light-gray-4;
}

.warning {
  color: $orange;
}

.emergency {
  color: $red;
}

.extra-thin {
  font-weight: $extra-bold;
}

.thin {
  font-weight: $thin;
}

.regular {
  font-weight: $regular;
}

.bold {
  font-weight: $bold;
}

.extra-bold {
  font-weight: $extra-bold;
}
</style>